/// <amd-module name="Tfs/Frame/Components/SignIn/SignIn" />
import * as React from "react";
import * as Resources from "Tfs/Frame/Resources";

import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";

import { Link } from "VSSUI/Link";

import { getHeaderActionData } from "Tfs/Platform/HeaderActions";

interface ISiginLinkState {
    signInUrl?: string;
}

export class SignInLink extends VssComponent<{}, ISiginLinkState> {
    public constructor(props: {}, context: IVssComponentContext) {
        super(props, context);

        const headerActionData = getHeaderActionData(context.pageContext) || {};
        this.state = {
            signInUrl: headerActionData.signInUrl
        };
    }

    public render(): JSX.Element {
        return (
            <Link className="sign-in-link commandbar-item" href={this.state.signInUrl}>
                {Resources.SignIn}
            </Link>
        );
    }
}

VssComponent.register("ms.vss-tfs-web.sign-in-link", SignInLink);
